import {
  Dic
} from '@src/common/utils'
// console.log('Dic',Dic.find("SENU073002"))
import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
const tableOption = function (staffShow, operateShow) {
  if (staffShow) {
    return {
      add: '新增',
      edit: '修改',
      view: '查看',
      page: true,
      selection: true,
      index: false,
      indexLabel: '序号',
      refreshBtn: false,
      columnBtn: false,
      stripe: true,
      addBtn: false,
      editBtn: false,
      delBtn: false,
      viewFormSlot: true,
      labelSuffix: '：',
      size: 'small',
      maxHeight: '100%',
      labelWidth: '0px',
      menuAlign: 'center',
      searchMenuSpan: 6,
      searchBtn: false,
      dialogHeight: 350,
      dialogWidth: '700px',
      emptyText: i18n.t('personAccess.title.noData'),
      menu: false,
      column: [{
          label: '车间名称',
          prop: 'workShopName',
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          // viewDisplay: false,
          overHidden: true,
          search: true,
          searchPlaceholder: '请输入车间名称',
          span: 12,
        },
        {
          label: '负责人',
          prop: 'directorPersonnelList',
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          overHidden: true,
          search: true,
          searchPlaceholder: '请选择负责人',
          span: 12,
        },
        {
          label: '班组负责人',
          prop: 'workShopMonitorPersonnerList',
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          // viewDisplay: false,
          overHidden: true,
          search: false,
          span: 12,
        },
        {
          label: '车间说明',
          prop: 'desc',
          search: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          span: 12,
        },
        {
          label: '车间所属楼栋',
          prop: 'workShopBuildingList',
          search: false,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          span: 12,
        },
        {
          label: '',//保卫账户列表
          prop: 'accountList',
          span: 24,
          formslot: true,
          hide: true
        }
      ]
    }
  }
}
export default tableOption